























































































































































import { Component, Vue } from "vue-property-decorator";
import { getAllTermsBySection, getDocuments } from "@/services";

import { Term, Document } from "@/interfaces";

import { date } from "quasar";

@Component
export default class DocumentsArea extends Vue {
  tab = "definitions";

  searchText = "";

  documents: Document[] = [];

  termsBySection!: Term[];

  termsBySectionFiltered: Term[] = [];

  loading = false;

  mounted() {
    this.loadTerms();
  }

  async loadTerms() {
    try {
      this.loading = true;
      this.termsBySection = await getAllTermsBySection();
      this.termsBySectionFiltered = this.termsBySection;
      this.documents = await getDocuments();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  termSearchSubmit() {
    if (this.searchText !== "") {
      this.termsBySectionFiltered = this.termsBySection.filter(term =>
        term.title.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.termsBySectionFiltered = this.termsBySection;
    }
  }

  getDate(element: Document) {
    return date.formatDate(element.updated_at, "DD/MM/YYYY HH:mm");
  }
}
